import axios from 'axios';

export class InstantCall {
  constructor() {
    this.client = axios.create({
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async endCall(url, event) {
    try {
      await this.client.post(url, {
        event,
      });
    } catch (error) {
      console.error('Failed to end call:', error);
    }
  }
}

export default new InstantCall();
